import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class MultiTenantService {

    protected enabled = false;

    protected tenants: Array<any>;

    protected scopeSubject: Subject<any> = new ReplaySubject<any>(1);

    public constructor() {
        if (this.getCurrentScope()) {
            this.enable();
        }
    }

    /**
     * Check if multi tenancy is enabled
     *
     * @returns {boolean}
     */
    public isEnabled() {
        return this.enabled;
    }

    /**
     * Enable the service
     */
    public enable() {
        this.enabled = true;
    }

    /**
     * Disable the service
     */
    public disable() {
        this.enabled = false;

        this.removeScope();
    }

    /**
     * Reset Multi Tenancy
     */
    public reset() {
        this.disable();
    }

    /**
     * Returns the current tenant scope
     *
     * @returns {any}
     */
    public getCurrentScope() {
        return localStorage.getItem('tenant_scope');
    }

    /**
     * Set the current scope
     *
     * @param {number} tenantId
     */
    public setCurrentScope(tenantId: number) {
        if (!tenantId) {
            return this.removeScope();
        }

        localStorage.setItem('tenant_scope', tenantId + '');

        this.scopeSubject.next(tenantId);
    }

    public removeScope(): void {
        localStorage.removeItem('tenant_scope');

        this.scopeSubject.next(null);
    }

    public getScope(): Observable<number> {
        return this.scopeSubject;
    }

    public hasScope(): Observable<boolean> {
        return this.scopeSubject
            .pipe(
                map((scope: number) => {
                    return !!scope;
                }),
            );
    }

    protected hasScopeTenantChildren() {
    }

    public onScopeChange(): Subject<any> {
        return this.scopeSubject;
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/authentication/services/multi-tenant.service.ts